export const en = {
  accept: 'OK',
  reject: 'Cancel',
  dayNames: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  today: 'Today',
  clear: 'Clear',
  dateFormat: 'dd.mm.yy',
  firstDayOfWeek: 1,
  emptyMessage: 'No data available',

  // 🌐 MultiSelect translations
  choose: 'Choose',
  filter: 'Filter',
  close: 'Close',
  apply: 'Apply',
  selectAll: 'Select All',
  unselectAll: 'Unselect All',
  emptyFilterMessage: 'No results found',
  emptySelectionMessage: 'No options selected',
  selectedItemsLabel: '{0} items selected',
  maxSelectedLabels: '{0} items selected',
  chipSelected: '{0} selected',

  first: 'First',
  last: 'Last',
  next: 'Next',
  previous: 'Previous',
  rowsPerPage: 'Rows per page',
  currentPageReport: '{first}–{last} of {totalRecords}',
};
